import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: calc(var(--spacing-3) / 2);
`;
